import { TState } from '~/src/store';

const selectProviderId = (state: TState): number => state.city.provider.providerId;

export default selectProviderId;
